/* Livarelle native theme interaction. Original code; no third-party assets. */
(() => {
  if (customElements.get('livarelle-orbit')) return;
  class LivarelleOrbit extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.items = [...this.querySelectorAll('[data-lv-orbit-index]')];
      this.panels = [...this.querySelectorAll('[data-lv-orbit-panel]')];
      this.stage = this.querySelector('[data-lv-orbit-stage]');
      this.track = this.querySelector('.lv-orbit-track');
      this.status = this.querySelector('[data-lv-orbit-status]');
      if (this.items.length < 2 || this.items.length !== this.panels.length) return;
      this.index = 0;
      const options = { signal: this.abort.signal };
      this.addEventListener('click', event => {
        if (this.dragged) { this.dragged = false; event.preventDefault(); return; }
        const item = event.target.closest('[data-lv-orbit-index]');
        const step = event.target.closest('[data-lv-orbit-step]');
        if (item) this.select(Number(item.dataset.lvOrbitIndex));
        else if (step) this.select(this.index + Number(step.dataset.lvOrbitStep));
      }, options);
      this.addEventListener('keydown', event => {
        if (!event.target.closest('.lv-orbit-item,.lv-orbit-controls button')) return;
        let next;
        if (event.key === 'ArrowRight') next = this.index + 1;
        if (event.key === 'ArrowLeft') next = this.index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.items.length - 1;
        if (next === undefined) return;
        event.preventDefault(); this.select(next);
      }, options);
      this.stage.addEventListener('pointerdown', event => {
        if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
        this.dragged = false; this.pointer = { id: event.pointerId, x: event.clientX, y: event.clientY };
      }, options);
      this.stage.addEventListener('pointerup', event => {
        if (!this.pointer || event.pointerId !== this.pointer.id) return;
        const dx = event.clientX - this.pointer.x, dy = event.clientY - this.pointer.y;
        this.pointer = null;
        if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        this.dragged = true; this.select(this.index + (dx < 0 ? 1 : -1));
      }, options);
      this.stage.addEventListener('pointercancel', () => { this.pointer = null; this.dragged = false; }, options);
      this.classList.add('is-ready');
      this.resize = new ResizeObserver(() => this.position()); this.resize.observe(this.track);
      this.select(0, false);
    }
    select(next, animate = true) {
      this.index = ((next % this.items.length) + this.items.length) % this.items.length;
      this.items.forEach((item, i) => item.setAttribute('aria-pressed', String(i === this.index)));
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== this.index;
        panel.classList.toggle('is-entering', animate && i === this.index);
      });
      this.status.textContent = `${this.index + 1} / ${this.items.length}`;
      this.position();
    }
    position() {
      if (!this.track) return;
      const width = this.track.clientWidth, height = this.track.clientHeight;
      this.items.forEach((item, i) => {
        const angle = ((i - this.index) / this.items.length) * Math.PI * 2 + Math.PI / 2;
        item.style.setProperty('--x', `${Math.cos(angle) * width * .46}px`);
        item.style.setProperty('--y', `${Math.sin(angle) * height * .46}px`);
        item.style.setProperty('--tilt', `${Math.cos(angle) * 8}deg`);
        item.style.setProperty('--scale', i === this.index ? '1.08' : '.9');
      });
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  }
  customElements.define('livarelle-orbit', LivarelleOrbit);
})();
